import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('../pages/about/about.component').then((m) => m.AboutComponent),
  },
  {
    path: 'coding',
    loadComponent: () =>
      import('../pages/works-template/works-template.component').then(
        (m) => m.WorksTemplateComponent
      ),
    data: {
      page: 'coding',
      cols: 3,
    },
  },
  {
    path: 'writing',
    loadComponent: () =>
      import('../pages/works-template/works-template.component').then(
        (m) => m.WorksTemplateComponent
      ),
    data: {
      page: 'writing',
      cols: 2,
    },
  },
  {
    path: 'music',
    loadComponent: () =>
      import('../pages/works-template/works-template.component').then(
        (m) => m.WorksTemplateComponent
      ),
    data: {
      page: 'music',
      cols: 2,
    },
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('../pages/contact/contact.component').then(
        (m) => m.ContactComponent
      ),
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('../pages/blog/blog.routes').then((m) => m.BLOG_ROUTES),
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];
